import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './reducers';
import initialStoreValues from './initialStoreValues';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from './helpers/logger';
import {loadDynatrace} from "./dynatrace";


loadDynatrace();

const store = configureStore({
    reducer: rootReducer,
    preloadedState: initialStoreValues,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(loggerMiddleware, thunkMiddleware),
    devTools: window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? true : false,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

serviceWorker.unregister();